import { TranslationKey } from "types";

export interface IOverviewBrandPrinciplesProps {
  items: IPrincipleSection[];
  title: string;
  isInView?: boolean;
}

export interface IPrincipleSection {
  id: string;
  playbackTimeInSeconds: number;
  title: TranslationKey;
  description?: TranslationKey;
  index: number;
  slides: IBrandPrincipleSlide[];
  lottie?: ILottieConfig;
  mobileLottie?: ILottieConfig;
  mobileBackground?: string;
}

interface ILottieConfig {
  file: unknown;
  loopSegments: unknown[];
}
export interface IBrandPrincipleSlide {
  id: string;
  text: TranslationKey;
  icon: React.ReactNode;
}

export enum SlideDirection {
  Left = "left",
  Right = "right",
}
